import {
  Box,
  Button,
  Grid,
  IconButton,
  OutlinedInput,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AppContext, gasEstimationForAll } from "../../utils";
import refrel from "./assets/refrel.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  ToastNotify,
  useMainnodeContract,
  useTokenContract,
} from "../../ConnectivityAss/hooks";
import { formatUnits } from "@ethersproject/units";
import Loading from "../../loading";

function RefrelSystem() {
  const mobile = useMediaQuery("(max-width:1050px)");
  const { account, signer, connect } = useContext(AppContext);
  const mainNodeContract = useMainnodeContract(signer);
  const tokenContract = useTokenContract(signer);
  const [color, setColor] = useState("white");

  const [loading, setloading] = useState(false);
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const [claimed, setclaimed] = useState(0);
  const [claimable, setclaimable] = useState(0);
  const init = async () => {
    const [{ claimedReward, claimable }, decimal] = await Promise.all([
      mainNodeContract._userReferReward(account),
      tokenContract.decimals(),
    ]);
    setclaimed(formatUnits(claimedReward, decimal));
    setclaimable(formatUnits(claimable, decimal));
  };
  useEffect(() => {
    if (account) {
      init();
    }
  }, [account]);

  const claimHandler = async () => {
    try {
      setloading(true);

      let data = [];
      let fn = mainNodeContract.estimateGas.claimReferReward;
      let tx = await mainNodeContract.claimReferReward(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();

      await init();
      setloading(false);

      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  return (
    <div>
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />
      <Box textAlign={"center"} mt={mobile ? "50px" : "100px"} width="100%">
        <img src={refrel} style={{ maxWidth: "419px", width: "100%" }} alt="" />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={mobile ? 12 : 4}>
          <Box
            className="border"
            width="100%"
            px={mobile ? "15px" : "43px"}
            py={mobile ? "20px" : "26px"}
            sx={{
              background: " rgba(248, 248, 248, 0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              zIndex: "1",
              fontFamily: "regular",
            }}
          >
            <Box
              sx={{
                fontSize: mobile ? "15px" : "20px",
                fontWeight: "400",
                color: "white",
                textAlign: "center",
                fontFamily: "regular",
              }}
            >
              Total Earnings ($CON)
            </Box>
            <Box
              sx={{
                fontSize: mobile ? "18px" : "30px",
                fontWeight: "400",
                color: "#FAA631",
                textAlign: "center",
              }}
            >
              {(+claimed + +claimable).toFixed(4)}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={mobile ? 12 : 4}>
          <Box
            className="border"
            width="100%"
            px={mobile ? "15px" : "43px"}
            py={mobile ? "20px" : "26px"}
            sx={{
              background: " rgba(248, 248, 248, 0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              zIndex: "1",
              fontFamily: "regular",
            }}
          >
            <Box
              sx={{
                fontSize: mobile ? "15px" : "20px",
                fontWeight: "400",
                color: "white",
                textAlign: "center",
                fontFamily: "regular",
              }}
            >
              Paid Earnings ($CON)
            </Box>
            <Box
              sx={{
                fontSize: mobile ? "18px" : "30px",
                fontWeight: "400",
                color: "#FAA631",
                textAlign: "center",
              }}
            >
        
              {(+claimed).toFixed(4)}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={mobile ? 12 : 4}>
          <Box
            className="border"
            width="100%"
            px={mobile ? "15px" : "43px"}
            py={mobile ? "20px" : "26px"}
            sx={{
              background: " rgba(248, 248, 248, 0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              zIndex: "1",
              fontFamily: "regular",
            }}
          >
            <Box
              sx={{
                fontSize: mobile ? "15px" : "20px",
                fontWeight: "400",
                color: "white",
                textAlign: "center",
                fontFamily: "regular",
              }}
            >
              Current Balance ($CON)
            </Box>
            <Box
              sx={{
                fontSize: mobile ? "18px" : "30px",
                fontWeight: "400",
                color: "#FAA631",
                textAlign: "center",
              }}
            >
              {(+claimable).toFixed(4)}
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/* grid 2  */}

      <Grid
        sx={{
          marginTop: "50px",
        }}
        container
        spacing={2}
      >
        <Grid item xs={mobile ? 12 : 8}>
          <Box
            sx={{
              fontSize: mobile ? "20px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: mobile ? "center" : "left",
              fontFamily: "semi",
            }}
          >
            How it works
          </Box>
          <Box
            sx={{
              fontSize: mobile ? "12px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: mobile ? "left" : "left",
              fontFamily: "regular",
              maxWidth: "561px",
              paddingLeft: "20px",
            }}
          >
            <ol>
              <li>Create a Node.</li>
              <li>Copy the unique Link in your Referral tab.</li>
              <li>
                Share the Link with your friends, ask them to create a Node.
              </li>
              <li>
                Once they do, you'll get <strong>5% commission,</strong> on the
                amount they used to create a node.
              </li>
            </ol>
          </Box>
        </Grid>

        <Grid item xs={mobile ? 12 : 4}>
          <Box
            sx={{
              fontSize: mobile ? "12px" : "18px",
              fontWeight: "400",
              color: "#FFFFFF",
              textAlign: mobile ? "center" : "left",
              fontFamily: "regular",
            }}
          >
            Your Referral Link
          </Box>
          <OutlinedInput
            mt="14px"
            readOnly
            id="outline"
            endAdornment={
              <>
                <IconButton
                  onClick={() => {
                    if (color === "white") {
                      setColor("lightblue");
                    } else {
                      setColor("white");
                    }
                  }}
                >
                  <CopyToClipboard
                    text={window.location.href + "/?ref=" + account}
                    onCopy={() => {
                      if (account) {
                        setAlertState({
                          open: true,
                          message: `Referal Link Copied to Clipboard`,
                          severity: "success",
                        });
                      }
                    }}
                  >
                    <Box
                      fontSize={mobile ? " 20px" : "15px"}
                      sx={{
                        color: color,
                        fontFamily: "regular",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Copy
                      <i class="fa-solid fa-copy"></i>
                    </Box>
                  </CopyToClipboard>
                </IconButton>
              </>
            }
            sx={{
              background: "#4A4A4A",
              borderRadius: "10px",
              width: "100%",
              height: "50px",
              color: "white",
              fontFamily: "regular",
            }}
            placeholder="Connect your wallet first..."
            value={
              account
                ? window.location.href + "/?ref=" + account
                : "Connect your wallet"
            }
          />
          {account ? (
            <Button
              sx={{
                fontSize: mobile ? "15px" : "25px",
                width: "100%",
                background: "#FAA631",
                "&:hover": {
                  background: "white",
                  color: "#FAA631",
                },
                color: "white",
                borderRadius: "10px",
                height: "43px",
                marginTop: mobile ? "10px" : "12px",
                fontFamily: "light",
              }}
              onClick={claimHandler}
            >
              withdraw commission
            </Button>
          ) : (
            <Button
              sx={{
                fontSize: mobile ? "15px" : "25px",
                width: "100%",
                background: "#FAA631",
                "&:hover": {
                  background: "white",
                  color: "#FAA631",
                },
                color: "white",
                borderRadius: "10px",
                height: "43px",
                marginTop: mobile ? "10px" : "12px",
                fontFamily: "light",
              }}
              onClick={connect}
            >
              CONNECT WALLET
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default RefrelSystem;
